module.exports = __webpack_public_path__ + "img/operate-2.1535b7e5.gif";